/* Dozzee — global behaviour: header, menu, language, cookies, colour store, notify forms,
   cart add (sell mode) and motion bootstrap. Section scripts build on window.Dozzee. */
(function () {
  var D = (window.Dozzee = window.Dozzee || {});
  var S = D.settings || {};
  D.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- helpers ---------- */
  D.$ = function (s, r) { return (r || document).querySelector(s); };
  D.$$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  D.lsGet = function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } };
  D.lsSet = function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} };
  D.validEmail = function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || '').trim()); };

  /* Run cb(gsap, ScrollTrigger, SplitText) once GSAP is loaded and fonts are ready. */
  D.gsap = function (cb) {
    var n = 0;
    (function wait() {
      if (window.gsap && window.ScrollTrigger && window.SplitText) {
        window.gsap.registerPlugin(window.ScrollTrigger, window.SplitText);
        var fonts = document.fonts ? Promise.race([document.fonts.ready, new Promise(function (r) { setTimeout(r, 2000); })]) : Promise.resolve();
        fonts.then(function () { cb(window.gsap, window.ScrollTrigger, window.SplitText); });
        return;
      }
      if (n++ < 150) setTimeout(wait, 60);
    })();
  };

  /* ---------- colours ---------- */
  D.colours = D.colours || [];
  try { localStorage.removeItem('dozzee.colour'); } catch (e) {} /* older visits saved a colour; forget it */
  D.colourBy = function (k) {
    k = String(k || '').toLowerCase();
    for (var i = 0; i < D.colours.length; i++) {
      var c = D.colours[i];
      if (c.key === k || c.name.toLowerCase() === k) return c;
    }
    return null;
  };
  D.getColour = function () {
    /* every page starts on the default colour (Cherry Rush); a pick only lasts for the page you're on */
    return D._colour || D.colourBy(S.startColour) || D.colours[0];
  };
  /* Remember for this page + broadcast. Listeners: document.addEventListener('dozzee:colour', e => e.detail) */
  D.setColour = function (k, source) {
    var c = D.colourBy(k);
    if (!c) return null;
    D._colour = c;
    document.dispatchEvent(new CustomEvent('dozzee:colour', { detail: { colour: c, source: source || null } }));
    return c;
  };
  D.tagFor = function (c) { return 'notify-' + c.name.toLowerCase().replace(/\s+/g, '-'); };

  /* ---------- notify forms ---------- */
  D.setNotifyTags = function (wrap, tags) {
    var inp = wrap && wrap.querySelector('[data-notify-tags]');
    if (inp) inp.value = Array.isArray(tags) ? tags.join(',') : tags;
  };
  D.resetNotify = function (wrap) {
    if (!wrap) return;
    wrap.classList.remove('is-done');
    var f = wrap.querySelector('form'), d = wrap.querySelector('[data-notify-done]'), er = wrap.querySelector('[data-notify-error]');
    if (f) f.hidden = false;
    if (d) d.hidden = true;
    if (er) er.hidden = true;
  };
  function showDone(wrap, email) {
    var f = wrap.querySelector('form'), d = wrap.querySelector('[data-notify-done]');
    D.$$('[data-email]', wrap).forEach(function (el) { el.textContent = email; });
    if (f) f.hidden = true;
    if (d) d.hidden = false;
    wrap.classList.add('is-done');
  }
  /* ---------- Shopify spam check (hCaptcha) on email forms ----------
     Shopify only switches its check on for a form when someone clicks into it, and it loads a script first.
     A form sent before that is silently stopped. So: switch it on as soon as a form comes near the screen,
     and if someone is quicker than that, hold the submit until it's ready, then send it. */
  D.captchaReady = function (form) {
    return !window.Shopify || !window.Shopify.captcha || form.dataset.hcaptchaBound === 'true' || form.dataset.recaptchaBound === 'true';
  };
  D.protectForm = function (form, done) {
    var C = window.Shopify && window.Shopify.captcha;
    if (!C || !C.protect) { if (done) done(); return; }
    if (form._dzProtected) { if (done) (form._dzWaiters = form._dzWaiters || []).push(done); return; }
    form._dzProtected = true; form._dzWaiters = done ? [done] : [];
    C.protect(form, function () { var w = form._dzWaiters || []; form._dzWaiters = []; w.forEach(function (fn) { fn(); }); });
  };
  D.watchCaptcha = function (form) {
    if (!('IntersectionObserver' in window)) return D.protectForm(form);
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); D.protectForm(form); } }, { rootMargin: '600px 0px' });
    io.observe(form);
  };
  /* in a submit handler: returns true when the submit may go ahead now; otherwise holds it and resends once ready */
  D.holdForCaptcha = function (e, form, onWait) {
    if (D.captchaReady(form)) return true;
    e.preventDefault();
    if (onWait) onWait();
    D.protectForm(form, function () { setTimeout(function () { form.requestSubmit ? form.requestSubmit() : form.submit(); }, 50); });
    return false;
  };

  /* The email is checked here, then the form posts normally (no fetch): Shopify adds its spam-protection
     token only on a normal submit and rejects fetch posts. Shopify then reloads the page at this form, and
     the snippet marks it [data-notify-posted]; the email and tags were kept in sessionStorage to show 'done'. */
  var NK = 'dozzee.notify';
  function initNotify(wrap) {
    if (wrap._dz) return; wrap._dz = 1;
    var form = wrap.querySelector('form'), err = wrap.querySelector('[data-notify-error]');
    if (!form) return;
    if (wrap.querySelector('[data-notify-posted]')) {
      var saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(NK) || 'null'); } catch (e) {}
      if (saved && saved.id === form.id) { try { sessionStorage.removeItem(NK); } catch (e) {} }
      else saved = null;
      var em = saved ? saved.email : '';
      showDone(wrap, em);
      /* let the section scripts attach their listeners first */
      setTimeout(function () { wrap.dispatchEvent(new CustomEvent('dozzee:notified', { bubbles: true, detail: { email: em, tags: saved ? saved.tags : '' } })); }, 400);
      /* Shopify reloads the page at the top (the #form link can't reach into the held/animated sections),
         so bring the confirmation back into view once the scroll animations have measured the page */
      setTimeout(function () {
        var y = wrap.getBoundingClientRect().top + (window.scrollY || 0) - window.innerHeight * 0.4;
        if (window.__dzLenis) window.__dzLenis.scrollTo(Math.max(0, y), { immediate: true });
        else window.scrollTo(0, Math.max(0, y));
      }, 1400);
    }
    form.addEventListener('submit', function (e) {
      var input = form.querySelector('input[type="email"]'), email = input ? input.value.trim() : '';
      if (!D.validEmail(email)) {
        e.preventDefault();
        if (err) { err.textContent = (D.strings && D.strings.emailInvalid) || 'Please enter a valid email address.'; err.hidden = false; }
        if (input) input.focus();
        return;
      }
      if (err) err.hidden = true;
      var btn = form.querySelector('[type="submit"]');
      if (!D.holdForCaptcha(e, form, function () { if (btn) btn.setAttribute('aria-busy', 'true'); })) return;
      var tags = (form.querySelector('[data-notify-tags]') || {}).value || '';
      try { sessionStorage.setItem(NK, JSON.stringify({ id: form.id, email: email, tags: tags })); } catch (x) {}
    });
    D.watchCaptcha(form);
  }
  D.initNotify = function (root) { D.$$('[data-notify]', root).forEach(initNotify); };

  /* ---------- add to cart (sell mode) ---------- */
  D.addToCart = function (variantId, qty) {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    }).then(function (r) { if (!r.ok) throw r; return D.refreshCart(); });
  };
  D.refreshCart = function () {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { D.$$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; }); return c; });
  };

  /* ---------- header ---------- */
  function initHeader() {
    var header = D.$('[data-header]'), menu = D.$('[data-menu]');
    if (!header) return;

    // language dropdowns
    D.$$('[data-lang]').forEach(function (box) {
      var btn = box.querySelector('[data-lang-toggle]'), list = box.querySelector('[data-lang-menu]');
      if (!btn || !list) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = list.hidden;
        D.$$('[data-lang-menu]').forEach(function (m) { m.hidden = true; });
        D.$$('[data-lang-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        list.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-lang]')) return;
      D.$$('[data-lang-menu]').forEach(function (m) { m.hidden = true; });
      D.$$('[data-lang-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    });

    // full-screen menu
    var openBtn = D.$('[data-menu-open]'), closeBtn = D.$('[data-menu-close]');
    function setMenu(open) {
      if (!menu) return;
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (D.lenis) open ? D.lenis.stop() : D.lenis.start();
      header.classList.remove('is-hidden');
      if (open && closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
    }
    if (openBtn) openBtn.addEventListener('click', function () { setMenu(true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setMenu(false); if (openBtn) openBtn.focus(); });
    if (menu) menu.addEventListener('click', function (e) { if (e.target.closest('nav a')) setMenu(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu && menu.classList.contains('is-open')) setMenu(false); });

    // hide on scroll down / show on scroll up (sub-pages)
    if (header.hasAttribute('data-autohide')) {
      var lastY = window.scrollY;
      window.addEventListener('scroll', function () {
        var y = window.scrollY, d = y - lastY;
        if (Math.abs(d) < 6) return;
        var hide = d > 0 && y > 240 && !(menu && menu.classList.contains('is-open'));
        header.classList.toggle('is-hidden', hide);
        lastY = y;
      }, { passive: true });
    }
  }

  /* ---------- cookies ---------- */

  /* ---------- home: keep-scrolling cue ---------- */
  /* Shown once you start scrolling past the hero cue, hidden again from the last section down
     (and while the cookie card is up, since both sit bottom-left). */
  function initKeepScroll() {
    var cue = D.$('[data-keep-scroll]');
    if (!cue) return;
    var heroCue = D.$('.hm-hero__scroll'), cookies = D.$('[data-cookies]');
    /* hide it at the last section (the sign-up box) as well as the footer: nothing left to scroll to, and it would sit on the form */
    var secs = D.$$('main .shopify-section'), foot = secs.length ? secs[secs.length - 1] : document.getElementById('site-footer');
    var heroIn = !!heroCue, footIn = false;
    cue.hidden = false; cue.classList.add('is-off');
    function update() {
      var cookieUp = cookies && !cookies.hidden; /* same corner as the cookie card */
      cue.classList.toggle('is-off', heroIn || footIn || cookieUp);
    }
    if (cookies && 'MutationObserver' in window) new MutationObserver(update).observe(cookies, { attributes: true, attributeFilter: ['hidden'] });
    /* the hero is pinned, so its own cue stays on screen while it fades: use scroll distance instead */
    function onScroll() {
      var h = heroIn, f = footIn;
      heroIn = !!heroCue && (window.scrollY || 0) < window.innerHeight * 0.35;
      footIn = !!foot && foot.getBoundingClientRect().top < window.innerHeight * 0.75; /* reached the last section, or past it */
      if (h !== heroIn || f !== footIn) update();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update);
    onScroll(); update();
    cue.addEventListener('click', function () {
      var y = (window.scrollY || 0) + window.innerHeight * 0.85;
      if (window.__dzLenis) window.__dzLenis.scrollTo(y); else window.scrollTo({ top: y, behavior: 'smooth' });
    });
  }

  function initCookies() {
    var card = D.$('[data-cookies]');
    if (!card) return;
    if (!D.lsGet('dozzee.cookies')) card.hidden = false;
    function set(v) {
      D.lsSet('dozzee.cookies', v);
      card.hidden = true;
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      var apply = function () {
        try {
          window.Shopify.customerPrivacy.setTrackingConsent(
            v === 'all' ? { analytics: true, marketing: true, preferences: true, sale_of_data: true }
                        : { analytics: false, marketing: false, preferences: false, sale_of_data: false },
            function () {});
        } catch (e) {}
      };
      if (cp) apply();
      else if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (er) { if (!er) apply(); });
      }
    }
    var a = card.querySelector('[data-cookies-accept]'), es = card.querySelector('[data-cookies-essential]');
    if (a) a.addEventListener('click', function () { set('all'); });
    if (es) es.addEventListener('click', function () { set('essential'); });
  }

  /* ---------- motion ---------- */
  function initMotion() {
    if (!window.DozzeeMotion) return;
    var root = D.$('.dz-root') || document.body;
    // Expose Lenis to section scripts once created by dozzee-motion.js.
    D._stopMotion = window.DozzeeMotion.init(root, { smooth: !!S.smooth });
    var tries = 0;
    (function grab() {
      if (window.__dzLenis) { D.lenis = window.__dzLenis; return; }
      if (tries++ < 100) setTimeout(grab, 100);
    })();
  }

  /* ---------- phones: card rows that move sideways as you scroll down ----------
     [data-hscroll] rows (Say bye bye, A day with Dozzee) pin in the middle of the screen and slide
     left while the page scrolls; with reduced motion they stay as normal swipe rows. */
  function initHScroll() {
    if (D.reduce || !document.querySelector('[data-hscroll]')) return;
    D.gsap(function (gsap) {
      var mm = gsap.matchMedia();
      mm.add('(max-width: 759px)', function () {
        var rows = D.$$('[data-hscroll]'), dir = S.rtl ? 1 : -1;
        document.documentElement.classList.add('dz-hpin');
        rows.forEach(function (row, idx) {
          row.classList.add('is-hpin');
          var sec = row.closest('.shopify-section') || row.parentElement;
          var dist = function () { return Math.max(0, row.scrollWidth - row.clientWidth); };
          gsap.to(row, {
            x: function () { return dir * dist(); }, ease: 'none',
            /* hold the whole section still (heading + cards) so the only movement is sideways */
            scrollTrigger: { trigger: sec, pin: sec, start: function () { return sec.offsetHeight <= window.innerHeight - 70 ? 'center 54%' : 'top 72px'; }, end: function () { return '+=' + dist() * 1.1; }, scrub: true, invalidateOnRefresh: true, anticipatePin: 1,
              /* these pins add scroll length: measure them first (top one first) so every section below starts in the right place */
              refreshPriority: 10 + rows.length - idx }
          });
        });
        return function () { document.documentElement.classList.remove('dz-hpin'); rows.forEach(function (r) { r.classList.remove('is-hpin'); }); };
      });
    });
  }

  /* ---------- keep scroll animations measured right ----------
     Sections set up at slightly different times (GSAP, fonts and images load in any order, more so on phones),
     and a pinned section that is set up late pushes everything below it down. Re-sort and re-measure once
     everything has run, after the page finishes loading, and whenever the page height changes. */
  function initScrollSync() {
    D.gsap(function (gsap, ST) {
      var lastH = 0, timer = 0;
      function sync() { ST.sort(); ST.refresh(); lastH = document.documentElement.scrollHeight; }
      function soon(ms) { clearTimeout(timer); timer = setTimeout(sync, ms || 250); }
      soon(600);
      if (document.readyState === 'complete') soon(900); else window.addEventListener('load', function () { soon(300); });
      if ('ResizeObserver' in window) {
        new ResizeObserver(function () {
          var h = document.documentElement.scrollHeight;
          if (Math.abs(h - lastH) > 4) soon(300);
        }).observe(document.body);
      }
    });
  }

  function boot() {
    initHeader();
    initCookies();
    initKeepScroll();
    D.initNotify(document);
    initMotion();
    initHScroll();
    initScrollSync();
    document.addEventListener('shopify:section:load', function (e) {
      D.initNotify(e.target);
      if (window.ScrollTrigger) setTimeout(function () { window.ScrollTrigger.refresh(); }, 100);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
